import { LoaderFunctionArgs, redirect } from 'react-router-dom'
import { protectedLoader } from './protectLoader'
import {
  CUSTOMER_ADMIN,
  CUSTOMER_SUPPORT,
  DISTRIBUTOR_ADMIN,
  DISTRIBUTOR_SUPPORT,
  PORTAL_ADMIN,
  PORTAL_SUPPORT,
} from '.'
import { lazyRoute } from '../utils/lazyRoute'

const holderRoutes = [
  {
    path: '/holders',
    lazy: lazyRoute(() => import('../pages/Portal/Holders')),
    loader: (args: LoaderFunctionArgs) =>
      protectedLoader(args, {
        allowedRoles: [
          PORTAL_ADMIN,
          PORTAL_SUPPORT,
          DISTRIBUTOR_ADMIN,
          DISTRIBUTOR_SUPPORT,
        ],
      }),
  },
  {
    path: '/holders/:holderId',
    lazy: lazyRoute(() => import('../pages/Portal/Holders/HolderDetails')),
    loader: (args: LoaderFunctionArgs) =>
      protectedLoader(args, {
        allowedRoles: [
          PORTAL_ADMIN,
          PORTAL_SUPPORT,
          DISTRIBUTOR_ADMIN,
          DISTRIBUTOR_SUPPORT,
          CUSTOMER_ADMIN,
          CUSTOMER_SUPPORT,
        ],
      }),
  },
  {
    path: '/holder/register',
    lazy: lazyRoute(
      () => import('../pages/Portal/Holders/RegisterHolder/RegisterHolder'),
    ),
    loader: ({ request }: LoaderFunctionArgs) => {
      const url = new URL(request.url)
      const token = url.searchParams.get('token')
      if (token) {
        return redirect(`/register/${encodeURIComponent(token)}`)
      }
      return null
    },
  },
  {
    path: '/register/:token',
    lazy: lazyRoute(
      () => import('../pages/Portal/Holders/RegisterHolder/RegisterHolder'),
    ),
  },
]

export default holderRoutes
